import DropDown from "@components/dropDown";
import { GiftCodeStepsEnums, PendingOrder } from "@interfaces/basket";
import { commafy } from "@lib/index";
import Basket from "assets/svg/basket.svg";
import { Button } from "components";
import gate from "gate";
import Cookies from "js-cookie";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";

import Card from "./Card";

const orderData: PendingOrder = {
  code: "",
  isEnable: false,
};
const Index = () => {
  const { push } = useRouter();
  // const [orderListPost, setOrderListPost] = useState<null | any>(null);
  const { data, refetch } = useQuery("order-list", () => gate.orderList(), {
    select: (data: any) => data.data.output,
    retry: 3,
    enabled: !!Cookies.get("access_token"),
  });
  // const { mutate: mutateOrderListPost, isLoading: isLoadingOrderListPost } =
  //   useMutation(gate.orderListPost, {
  //     onSuccess: (data: any) => {
  //       setOrderListPost(data?.data?.output);
  //     },
  //     onError: (data: any) => {
  //       if (!data?.handleGlobally) {
  //         toast.error(data?.data?.message);
  //       }
  //     },
  //   });
  // const { mutate: mutateOrderListPost, isLoading: isLoadingOrderListPost } =
  //   useMutation(
  //     gate.orderListPost,
  //     {
  //       onSuccess: (data: any) => {
  //         setOrderListPost(data?.data?.output);
  //       },
  //       onError: (data: any) => {
  //         if (!data?.handleGlobally) {
  //           toast.error(data?.data?.message);
  //         }
  //       },
  //     },
  //     {
  //       retry: 3,
  //       enabled: !!Cookies.get("access_token"),
  //     }
  //   );
  const { mutate, isLoading } = useMutation(gate.deleteOrder, {
    onSuccess: () => {
      refetch();
    },
  });
  // useEffect(() => {
  //   mutateOrderListPost(orderData);
  // }, []);
  return (
    <>
      <Link href={"/basket"}>
        <div className="relative ml-5 cursor-pointer xl:hidden">
          <Basket />
          {!!data?.count && (
            <div className="absolute -top-1 -left-2 flex h-4 w-4 items-center justify-center rounded-full bg-white text-black-450">
              {data?.count}
            </div>
          )}{" "}
        </div>
      </Link>
      <div className="hidden xl:block">
        <DropDown
          svg_class="hidden"
          btnClass={"bg-transparent !h-auto pb-0 flex border-0"}
          menu_class="md:w-[472px] w-[75vw] -right-[60vw] sm:-right-[68vw] md:-right-[415px] p-5 z-[1000] text-black-450"
          isLeft={true}
          title={
            <div className="relative cursor-pointer">
              <Basket />
              {!!data?.count && (
                <div className="absolute -top-1 -left-2 flex h-4 w-4 items-center justify-center rounded-full bg-white text-black-450">
                  {data?.count}
                </div>
              )}{" "}
            </div>
          }
        >
          {!!data?.count && (
            <>
              <div className="mb-5">
                <div className="border-b border-[#B8B7B7] pb-5 text-xs md:text-base">
                  {data?.count} مورد موجودی سبد خرید
                </div>
              </div>
              <ul className="scrollbar-none mb-5 max-h-96 overflow-y-auto overflow-x-hidden border-b border-[#B8B7B7] pb-5">
                {data?.orderItems.map((item: any, index: number) => (
                  <Card item={item} key={JSON.stringify(item?.id)} />
                ))}
              </ul>
            </>
          )}{" "}
          {data?.count == 0 && (
            <div className="grid-template-columns-max grid grid-flow-col gap-x-2">
              <span className="flex h-5 w-5 items-center justify-center rounded-full bg-slate-300">
                !
              </span>
              سبد خرید شما خالی است.
            </div>
          )}
          {!!data?.count && (
            <div className="flex w-full items-center justify-between">
              <span>
                <span className="text-xs md:text-base">مجموع:</span>
                <span className="text-[9px] md:text-base">
                  {commafy(data?.totalPrice - data?.totalDiscount)} تومان
                </span>
              </span>
              <Button
                onClick={() => push("/basket")}
                className="rounded bg-[#0577AF]/20 px-4 py-[10px] text-xs text-[#0577AF] md:px-5 md:text-base"
              >
                تکمیل فرآیند خرید
              </Button>
            </div>
          )}
        </DropDown>
      </div>
    </>
  );
};

export default Index;
